export function mergeArraysOn<T, T2>(
    arr1: T[],
    arr2: T2[],
    mergeTestFunc: (arr1Val: T, arr2Val: T2) => boolean,
): Array<Partial<T2> & T> {
    return arr1.map(a1Val => ({
        ...a1Val,
        ...arr2.find(a2Val => mergeTestFunc(a1Val, a2Val)),
    }));
}
